import AssociatedContactsSelectorContainer from './containers/AssociatedContactsSelectorContainer'

export default AssociatedContactsSelectorContainer
